import React, { ReactNode } from 'react'
import classNames from 'classnames'
import Image from 'next/image'
import { Icon } from '@/ui/atoms/Icon'

type WelcomeLayoutProps = {
  className?: string
  children?: ReactNode
}

export const WelcomeLayout: React.FC<WelcomeLayoutProps> = ({
  className: classNameFromProps,
  children,
}) => {
  return (
    <div className={classNames(classNameFromProps)}>
      <div
        className={
          'flex flex-col lg:flex-row items-center gap-12 lg:gap-20 w-full max-w-[1920px] lg:px-20'
        }
      >
        <div className={'max-w-[720px]'}>
          <Image
            className={'mb-12 mx-auto lg:mx-0'}
            src={'/ea-logo-2x.webp'}
            width={200}
            height={100}
            alt={''}
          />
          <h1
            className={
              'text-text-inverted text-center lg:text-start text-headline-XL-semibold mb-0 lg:mb-16 w-full'
            }
          >
            Welcome to Electrification Academy
          </h1>
          <div className={'hidden lg:block'}>
            <ul>
              <li className={'flex flex-row gap-3 mb-6 max-w-[400px]'}>
                <Icon className={'text-text-inverted mt-0.5 !size-5'} name={'check-circle'} />
                <div className={''}>
                  <p className={'text-text-inverted text-body-M-semibold mb-1'}>
                    Expert-Vetted Knowledge
                  </p>
                  <p className={'text-text-faded-inverted text-body-M-regular'}>
                    All content is curated and verified by leading professionals in battery
                    recycling, EV manufacturing, and energy storage.
                  </p>
                </div>
              </li>
              <li className={'flex flex-row gap-3 mb-6 max-w-[400px]'}>
                <Icon className={'text-text-inverted mt-0.5 !size-5'} name={'check-circle'} />
                <div className={''}>
                  <p className={'text-text-inverted text-body-M-semibold mb-1'}>
                    Application-Focused Insights
                  </p>
                  <p className={'text-text-faded-inverted text-body-M-regular'}>
                    Access real-world use cases, process walkthroughs, and peer-reviewed solutions
                    that help you act — not just learn.
                  </p>
                </div>
              </li>
              <li className={'flex flex-row gap-3 mb-6 max-w-[400px]'}>
                <Icon className={'text-text-inverted mt-0.5 !size-5'} name={'check-circle'} />
                <div className={''}>
                  <p className={'text-text-inverted text-body-M-semibold mb-1'}>
                    Your B2B Learning Hub
                  </p>
                  <p className={'text-text-faded-inverted text-body-M-regular'}>
                    Explore structured content, product evaluations, and ecosystem insights tailored
                    to your industry role and goals.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
